import script from "./JoinSuccess.vue?vue&type=script&setup=true&lang=ts"
export * from "./JoinSuccess.vue?vue&type=script&setup=true&lang=ts"

import "./JoinSuccess.vue?vue&type=style&index=0&id=77a3966d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77a3966d"]])

export default __exports__